import PaymentDelivery from "./payment-delivery";

export default PaymentDelivery;